import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoDiagnosticPlanViewModel } from 'src/app/model/odonto/diagnostic-plan.view';
import esTranslation from 'src/assets/translations/es.json';

@Component({
  selector: 'ms-odonto-diagnostic-plan',
  templateUrl: './odonto.diagnostic-plan.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoDiagnosticPlanComponent,
      multi: true,
    },
  ],
})
export class OdontoDiagnosticPlanComponent extends BaseValueAccessor<
  OdontoDiagnosticPlanViewModel[]
> {
  readonly screen = esTranslation;
  @Input() turn = -1;
  @Input() readonly = false;

  showDetails = false;
  expandSection = true;

  handleUpdateGlobalField = ($ev: OdontoDiagnosticPlanViewModel) => {};

  get mainDetail() {
    if (!this.value) {
      return undefined;
    }
    return this.value.find((item) => item.id === 'odo_pln_00');
  }

  get catalogs() {
    if (!this.value) {
      return [];
    }
    return this.value.filter((item) => item.id !== 'odo_pln_00');
  }

  get catalogsName() {
    return this.catalogs
      .filter((item) => item.details && item.details?.trim().length > 0)
      .map((item) => item.name)
      .join('; ');
  }
}
